import React, {Fragment} from 'react'
import {ErrorMessage} from "formik";
import FormLabel from 'components/form/FormLabel'
import FormSelect from "components/form/FormSelect";

type PropsType = {
    name: string
    label: string | React.ReactNode
    autoComplete?: string
    noClassName?: boolean
    type?: string
    className?: string
    inputProps?: any
    required?: boolean
    disabled?: boolean
    formikField?: boolean
    error?: string | null
    placeholder?: string | null
    onChange?: (e: any) => void
    value?: any
    children?: React.ReactNode
}

function Select(props: PropsType) {
    const {
        name,
        label,
        autoComplete = undefined,
        type = 'text',
        className = '',
        inputProps = {},
        required = false,
        disabled = false,
        formikField = true,
        error = null,
        placeholder = null,
        noClassName = false
    } = props
    return (
        <div className={`c__select ${className} ${disabled ? '-disabled' : ''}`}>
            <FormLabel required={required} htmlFor={name}>
                {label}
            </FormLabel>
            <FormSelect
                {...inputProps}
                noClassName={noClassName}
                autoComplete={autoComplete}
                disabled={disabled}
                placeholder={placeholder}
                id={name}
                formikField={formikField}
                type={type}
                name={name}
                {...formikField ? {} : {
                    value: props.value,
                    onChange: props.onChange
                }}
            >
                {props.children}
            </FormSelect>
            {formikField ? (
                <ErrorMessage name={name} component="p" className="error"/>
            ) : (
                <Fragment>
                    {error && (
                        <p className="error">{error}</p>
                    )}
                </Fragment>

            )}

        </div>
    )
}

export default Select

